// extracted by mini-css-extract-plugin
module.exports = {"header":"Layout_header__3EItT","main":"Layout_main__1dFZc","extendMain":"Layout_extendMain__3baU6","familynfo":"Layout_familynfo__1WEgz"};